package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets22 {
  internal val names_25_zecharia_01_txt: AssetResource by lazy { init_names_25_zecharia_01_txt() }

  internal val names_25_zecharia_03_txt: AssetResource by lazy { init_names_25_zecharia_03_txt() }

  internal val names_25_zecharia_04_txt: AssetResource by lazy { init_names_25_zecharia_04_txt() }

  internal val names_25_zecharia_06_txt: AssetResource by lazy { init_names_25_zecharia_06_txt() }

  internal val names_25_zecharia_07_txt: AssetResource by lazy { init_names_25_zecharia_07_txt() }

  internal val names_25_zecharia_txt: AssetResource by lazy { init_names_25_zecharia_txt() }

  internal val names_26_malachi_txt: AssetResource by lazy { init_names_26_malachi_txt() }

  internal val names_27_tehilim_072_txt: AssetResource by lazy { init_names_27_tehilim_072_txt() }

  internal val names_27_tehilim_127_txt: AssetResource by lazy { init_names_27_tehilim_127_txt() }

  internal val names_27_tehilim_txt: AssetResource by lazy { init_names_27_tehilim_txt() }

  internal val names_28_mishley_25_txt: AssetResource by lazy { init_names_28_mishley_25_txt() }

  internal val names_28_mishley_30_txt: AssetResource by lazy { init_names_28_mishley_30_txt() }

  internal val names_28_mishley_31_txt: AssetResource by lazy { init_names_28_mishley_31_txt() }

  internal val names_28_mishley_txt: AssetResource by lazy { init_names_28_mishley_txt() }

  internal val names_29_iyov_01_txt: AssetResource by lazy { init_names_29_iyov_01_txt() }

  internal val names_29_iyov_02_txt: AssetResource by lazy { init_names_29_iyov_02_txt() }

  internal val names_29_iyov_32_txt: AssetResource by lazy { init_names_29_iyov_32_txt() }

  internal val names_29_iyov_42_txt: AssetResource by lazy { init_names_29_iyov_42_txt() }

  internal val names_29_iyov_txt: AssetResource by lazy { init_names_29_iyov_txt() }

  internal val names_2_shemot_01_txt: AssetResource by lazy { init_names_2_shemot_01_txt() }

  internal val names_2_shemot_02_txt: AssetResource by lazy { init_names_2_shemot_02_txt() }

  internal val names_2_shemot_04_txt: AssetResource by lazy { init_names_2_shemot_04_txt() }

  internal val names_2_shemot_06_txt: AssetResource by lazy { init_names_2_shemot_06_txt() }

  internal val names_2_shemot_13_txt: AssetResource by lazy { init_names_2_shemot_13_txt() }

  internal val names_2_shemot_17_txt: AssetResource by lazy { init_names_2_shemot_17_txt() }

  internal val names_2_shemot_18_txt: AssetResource by lazy { init_names_2_shemot_18_txt() }

  internal val names_2_shemot_33_txt: AssetResource by lazy { init_names_2_shemot_33_txt() }

  internal val names_2_shemot_35_txt: AssetResource by lazy { init_names_2_shemot_35_txt() }

  internal val names_2_shemot_37_txt: AssetResource by lazy { init_names_2_shemot_37_txt() }

  internal val names_2_shemot_38_txt: AssetResource by lazy { init_names_2_shemot_38_txt() }

  internal val names_2_shemot_txt: AssetResource by lazy { init_names_2_shemot_txt() }

  internal val names_30_shir_hashirim_txt: AssetResource by lazy { init_names_30_shir_hashirim_txt()
      }

  internal val names_31_ruth_txt: AssetResource by lazy { init_names_31_ruth_txt() }

  internal val names_32_eicha_txt: AssetResource by lazy { init_names_32_eicha_txt() }

  internal val names_33_koheleth_txt: AssetResource by lazy { init_names_33_koheleth_txt() }

  internal val names_34_ester_01_txt: AssetResource by lazy { init_names_34_ester_01_txt() }

  internal val names_34_ester_02_txt: AssetResource by lazy { init_names_34_ester_02_txt() }

  internal val names_34_ester_04_txt: AssetResource by lazy { init_names_34_ester_04_txt() }

  internal val names_34_ester_05_txt: AssetResource by lazy { init_names_34_ester_05_txt() }

  internal val names_34_ester_06_txt: AssetResource by lazy { init_names_34_ester_06_txt() }

  internal val names_34_ester_09_txt: AssetResource by lazy { init_names_34_ester_09_txt() }

  internal val names_34_ester_txt: AssetResource by lazy { init_names_34_ester_txt() }

  internal val names_35_daniel_01_txt: AssetResource by lazy { init_names_35_daniel_01_txt() }

  internal val names_35_daniel_02_txt: AssetResource by lazy { init_names_35_daniel_02_txt() }

  internal val names_35_daniel_04_txt: AssetResource by lazy { init_names_35_daniel_04_txt() }

  internal val names_35_daniel_05_txt: AssetResource by lazy { init_names_35_daniel_05_txt() }

  internal val names_35_daniel_08_txt: AssetResource by lazy { init_names_35_daniel_08_txt() }

  internal val names_35_daniel_09_txt: AssetResource by lazy { init_names_35_daniel_09_txt() }

  internal val names_35_daniel_10_txt: AssetResource by lazy { init_names_35_daniel_10_txt() }

  internal val names_35_daniel_12_txt: AssetResource by lazy { init_names_35_daniel_12_txt() }

  internal fun values(): List<AssetResource> = listOf(names_25_zecharia_01_txt,
      names_25_zecharia_03_txt, names_25_zecharia_04_txt, names_25_zecharia_06_txt,
      names_25_zecharia_07_txt, names_25_zecharia_txt, names_26_malachi_txt,
      names_27_tehilim_072_txt, names_27_tehilim_127_txt, names_27_tehilim_txt,
      names_28_mishley_25_txt, names_28_mishley_30_txt, names_28_mishley_31_txt,
      names_28_mishley_txt, names_29_iyov_01_txt, names_29_iyov_02_txt, names_29_iyov_32_txt,
      names_29_iyov_42_txt, names_29_iyov_txt, names_2_shemot_01_txt, names_2_shemot_02_txt,
      names_2_shemot_04_txt, names_2_shemot_06_txt, names_2_shemot_13_txt, names_2_shemot_17_txt,
      names_2_shemot_18_txt, names_2_shemot_33_txt, names_2_shemot_35_txt, names_2_shemot_37_txt,
      names_2_shemot_38_txt, names_2_shemot_txt, names_30_shir_hashirim_txt, names_31_ruth_txt,
      names_32_eicha_txt, names_33_koheleth_txt, names_34_ester_01_txt, names_34_ester_02_txt,
      names_34_ester_04_txt, names_34_ester_05_txt, names_34_ester_06_txt, names_34_ester_09_txt,
      names_34_ester_txt, names_35_daniel_01_txt, names_35_daniel_02_txt, names_35_daniel_04_txt,
      names_35_daniel_05_txt, names_35_daniel_08_txt, names_35_daniel_09_txt,
      names_35_daniel_10_txt, names_35_daniel_12_txt)
}

private fun init_names_25_zecharia_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_25_zecharia-01.txt\")") as String, rawPath =
    "peopleNames/names_25_zecharia-01.txt")

private fun init_names_25_zecharia_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_25_zecharia-03.txt\")") as String, rawPath =
    "peopleNames/names_25_zecharia-03.txt")

private fun init_names_25_zecharia_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_25_zecharia-04.txt\")") as String, rawPath =
    "peopleNames/names_25_zecharia-04.txt")

private fun init_names_25_zecharia_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_25_zecharia-06.txt\")") as String, rawPath =
    "peopleNames/names_25_zecharia-06.txt")

private fun init_names_25_zecharia_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_25_zecharia-07.txt\")") as String, rawPath =
    "peopleNames/names_25_zecharia-07.txt")

private fun init_names_25_zecharia_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_25_zecharia.txt\")") as String, rawPath =
    "peopleNames/names_25_zecharia.txt")

private fun init_names_26_malachi_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_26_malachi.txt\")") as String, rawPath =
    "peopleNames/names_26_malachi.txt")

private fun init_names_27_tehilim_072_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_27_tehilim-072.txt\")") as String, rawPath =
    "peopleNames/names_27_tehilim-072.txt")

private fun init_names_27_tehilim_127_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_27_tehilim-127.txt\")") as String, rawPath =
    "peopleNames/names_27_tehilim-127.txt")

private fun init_names_27_tehilim_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_27_tehilim.txt\")") as String, rawPath =
    "peopleNames/names_27_tehilim.txt")

private fun init_names_28_mishley_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_28_mishley-25.txt\")") as String, rawPath =
    "peopleNames/names_28_mishley-25.txt")

private fun init_names_28_mishley_30_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_28_mishley-30.txt\")") as String, rawPath =
    "peopleNames/names_28_mishley-30.txt")

private fun init_names_28_mishley_31_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_28_mishley-31.txt\")") as String, rawPath =
    "peopleNames/names_28_mishley-31.txt")

private fun init_names_28_mishley_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_28_mishley.txt\")") as String, rawPath =
    "peopleNames/names_28_mishley.txt")

private fun init_names_29_iyov_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_29_iyov-01.txt\")") as String, rawPath =
    "peopleNames/names_29_iyov-01.txt")

private fun init_names_29_iyov_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_29_iyov-02.txt\")") as String, rawPath =
    "peopleNames/names_29_iyov-02.txt")

private fun init_names_29_iyov_32_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_29_iyov-32.txt\")") as String, rawPath =
    "peopleNames/names_29_iyov-32.txt")

private fun init_names_29_iyov_42_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_29_iyov-42.txt\")") as String, rawPath =
    "peopleNames/names_29_iyov-42.txt")

private fun init_names_29_iyov_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_29_iyov.txt\")") as String, rawPath =
    "peopleNames/names_29_iyov.txt")

private fun init_names_2_shemot_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_2_shemot-01.txt\")") as String, rawPath =
    "peopleNames/names_2_shemot-01.txt")

private fun init_names_2_shemot_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_2_shemot-02.txt\")") as String, rawPath =
    "peopleNames/names_2_shemot-02.txt")

private fun init_names_2_shemot_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_2_shemot-04.txt\")") as String, rawPath =
    "peopleNames/names_2_shemot-04.txt")

private fun init_names_2_shemot_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_2_shemot-06.txt\")") as String, rawPath =
    "peopleNames/names_2_shemot-06.txt")

private fun init_names_2_shemot_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_2_shemot-13.txt\")") as String, rawPath =
    "peopleNames/names_2_shemot-13.txt")

private fun init_names_2_shemot_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_2_shemot-17.txt\")") as String, rawPath =
    "peopleNames/names_2_shemot-17.txt")

private fun init_names_2_shemot_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_2_shemot-18.txt\")") as String, rawPath =
    "peopleNames/names_2_shemot-18.txt")

private fun init_names_2_shemot_33_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_2_shemot-33.txt\")") as String, rawPath =
    "peopleNames/names_2_shemot-33.txt")

private fun init_names_2_shemot_35_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_2_shemot-35.txt\")") as String, rawPath =
    "peopleNames/names_2_shemot-35.txt")

private fun init_names_2_shemot_37_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_2_shemot-37.txt\")") as String, rawPath =
    "peopleNames/names_2_shemot-37.txt")

private fun init_names_2_shemot_38_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_2_shemot-38.txt\")") as String, rawPath =
    "peopleNames/names_2_shemot-38.txt")

private fun init_names_2_shemot_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_2_shemot.txt\")") as String, rawPath =
    "peopleNames/names_2_shemot.txt")

private fun init_names_30_shir_hashirim_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_30_shir_hashirim.txt\")") as String, rawPath =
    "peopleNames/names_30_shir_hashirim.txt")

private fun init_names_31_ruth_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_31_ruth.txt\")") as String, rawPath =
    "peopleNames/names_31_ruth.txt")

private fun init_names_32_eicha_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_32_eicha.txt\")") as String, rawPath =
    "peopleNames/names_32_eicha.txt")

private fun init_names_33_koheleth_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_33_koheleth.txt\")") as String, rawPath =
    "peopleNames/names_33_koheleth.txt")

private fun init_names_34_ester_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_34_ester-01.txt\")") as String, rawPath =
    "peopleNames/names_34_ester-01.txt")

private fun init_names_34_ester_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_34_ester-02.txt\")") as String, rawPath =
    "peopleNames/names_34_ester-02.txt")

private fun init_names_34_ester_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_34_ester-04.txt\")") as String, rawPath =
    "peopleNames/names_34_ester-04.txt")

private fun init_names_34_ester_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_34_ester-05.txt\")") as String, rawPath =
    "peopleNames/names_34_ester-05.txt")

private fun init_names_34_ester_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_34_ester-06.txt\")") as String, rawPath =
    "peopleNames/names_34_ester-06.txt")

private fun init_names_34_ester_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_34_ester-09.txt\")") as String, rawPath =
    "peopleNames/names_34_ester-09.txt")

private fun init_names_34_ester_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_34_ester.txt\")") as String, rawPath =
    "peopleNames/names_34_ester.txt")

private fun init_names_35_daniel_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_35_daniel-01.txt\")") as String, rawPath =
    "peopleNames/names_35_daniel-01.txt")

private fun init_names_35_daniel_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_35_daniel-02.txt\")") as String, rawPath =
    "peopleNames/names_35_daniel-02.txt")

private fun init_names_35_daniel_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_35_daniel-04.txt\")") as String, rawPath =
    "peopleNames/names_35_daniel-04.txt")

private fun init_names_35_daniel_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_35_daniel-05.txt\")") as String, rawPath =
    "peopleNames/names_35_daniel-05.txt")

private fun init_names_35_daniel_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_35_daniel-08.txt\")") as String, rawPath =
    "peopleNames/names_35_daniel-08.txt")

private fun init_names_35_daniel_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_35_daniel-09.txt\")") as String, rawPath =
    "peopleNames/names_35_daniel-09.txt")

private fun init_names_35_daniel_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_35_daniel-10.txt\")") as String, rawPath =
    "peopleNames/names_35_daniel-10.txt")

private fun init_names_35_daniel_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/peopleNames/names_35_daniel-12.txt\")") as String, rawPath =
    "peopleNames/names_35_daniel-12.txt")

public actual val SharedRes.assets.peopleNames.names_25_zecharia_01_txt: AssetResource
  get() = CommonMainAssets22.names_25_zecharia_01_txt

public actual val SharedRes.assets.peopleNames.names_25_zecharia_03_txt: AssetResource
  get() = CommonMainAssets22.names_25_zecharia_03_txt

public actual val SharedRes.assets.peopleNames.names_25_zecharia_04_txt: AssetResource
  get() = CommonMainAssets22.names_25_zecharia_04_txt

public actual val SharedRes.assets.peopleNames.names_25_zecharia_06_txt: AssetResource
  get() = CommonMainAssets22.names_25_zecharia_06_txt

public actual val SharedRes.assets.peopleNames.names_25_zecharia_07_txt: AssetResource
  get() = CommonMainAssets22.names_25_zecharia_07_txt

public actual val SharedRes.assets.peopleNames.names_25_zecharia_txt: AssetResource
  get() = CommonMainAssets22.names_25_zecharia_txt

public actual val SharedRes.assets.peopleNames.names_26_malachi_txt: AssetResource
  get() = CommonMainAssets22.names_26_malachi_txt

public actual val SharedRes.assets.peopleNames.names_27_tehilim_072_txt: AssetResource
  get() = CommonMainAssets22.names_27_tehilim_072_txt

public actual val SharedRes.assets.peopleNames.names_27_tehilim_127_txt: AssetResource
  get() = CommonMainAssets22.names_27_tehilim_127_txt

public actual val SharedRes.assets.peopleNames.names_27_tehilim_txt: AssetResource
  get() = CommonMainAssets22.names_27_tehilim_txt

public actual val SharedRes.assets.peopleNames.names_28_mishley_25_txt: AssetResource
  get() = CommonMainAssets22.names_28_mishley_25_txt

public actual val SharedRes.assets.peopleNames.names_28_mishley_30_txt: AssetResource
  get() = CommonMainAssets22.names_28_mishley_30_txt

public actual val SharedRes.assets.peopleNames.names_28_mishley_31_txt: AssetResource
  get() = CommonMainAssets22.names_28_mishley_31_txt

public actual val SharedRes.assets.peopleNames.names_28_mishley_txt: AssetResource
  get() = CommonMainAssets22.names_28_mishley_txt

public actual val SharedRes.assets.peopleNames.names_29_iyov_01_txt: AssetResource
  get() = CommonMainAssets22.names_29_iyov_01_txt

public actual val SharedRes.assets.peopleNames.names_29_iyov_02_txt: AssetResource
  get() = CommonMainAssets22.names_29_iyov_02_txt

public actual val SharedRes.assets.peopleNames.names_29_iyov_32_txt: AssetResource
  get() = CommonMainAssets22.names_29_iyov_32_txt

public actual val SharedRes.assets.peopleNames.names_29_iyov_42_txt: AssetResource
  get() = CommonMainAssets22.names_29_iyov_42_txt

public actual val SharedRes.assets.peopleNames.names_29_iyov_txt: AssetResource
  get() = CommonMainAssets22.names_29_iyov_txt

public actual val SharedRes.assets.peopleNames.names_2_shemot_01_txt: AssetResource
  get() = CommonMainAssets22.names_2_shemot_01_txt

public actual val SharedRes.assets.peopleNames.names_2_shemot_02_txt: AssetResource
  get() = CommonMainAssets22.names_2_shemot_02_txt

public actual val SharedRes.assets.peopleNames.names_2_shemot_04_txt: AssetResource
  get() = CommonMainAssets22.names_2_shemot_04_txt

public actual val SharedRes.assets.peopleNames.names_2_shemot_06_txt: AssetResource
  get() = CommonMainAssets22.names_2_shemot_06_txt

public actual val SharedRes.assets.peopleNames.names_2_shemot_13_txt: AssetResource
  get() = CommonMainAssets22.names_2_shemot_13_txt

public actual val SharedRes.assets.peopleNames.names_2_shemot_17_txt: AssetResource
  get() = CommonMainAssets22.names_2_shemot_17_txt

public actual val SharedRes.assets.peopleNames.names_2_shemot_18_txt: AssetResource
  get() = CommonMainAssets22.names_2_shemot_18_txt

public actual val SharedRes.assets.peopleNames.names_2_shemot_33_txt: AssetResource
  get() = CommonMainAssets22.names_2_shemot_33_txt

public actual val SharedRes.assets.peopleNames.names_2_shemot_35_txt: AssetResource
  get() = CommonMainAssets22.names_2_shemot_35_txt

public actual val SharedRes.assets.peopleNames.names_2_shemot_37_txt: AssetResource
  get() = CommonMainAssets22.names_2_shemot_37_txt

public actual val SharedRes.assets.peopleNames.names_2_shemot_38_txt: AssetResource
  get() = CommonMainAssets22.names_2_shemot_38_txt

public actual val SharedRes.assets.peopleNames.names_2_shemot_txt: AssetResource
  get() = CommonMainAssets22.names_2_shemot_txt

public actual val SharedRes.assets.peopleNames.names_30_shir_hashirim_txt: AssetResource
  get() = CommonMainAssets22.names_30_shir_hashirim_txt

public actual val SharedRes.assets.peopleNames.names_31_ruth_txt: AssetResource
  get() = CommonMainAssets22.names_31_ruth_txt

public actual val SharedRes.assets.peopleNames.names_32_eicha_txt: AssetResource
  get() = CommonMainAssets22.names_32_eicha_txt

public actual val SharedRes.assets.peopleNames.names_33_koheleth_txt: AssetResource
  get() = CommonMainAssets22.names_33_koheleth_txt

public actual val SharedRes.assets.peopleNames.names_34_ester_01_txt: AssetResource
  get() = CommonMainAssets22.names_34_ester_01_txt

public actual val SharedRes.assets.peopleNames.names_34_ester_02_txt: AssetResource
  get() = CommonMainAssets22.names_34_ester_02_txt

public actual val SharedRes.assets.peopleNames.names_34_ester_04_txt: AssetResource
  get() = CommonMainAssets22.names_34_ester_04_txt

public actual val SharedRes.assets.peopleNames.names_34_ester_05_txt: AssetResource
  get() = CommonMainAssets22.names_34_ester_05_txt

public actual val SharedRes.assets.peopleNames.names_34_ester_06_txt: AssetResource
  get() = CommonMainAssets22.names_34_ester_06_txt

public actual val SharedRes.assets.peopleNames.names_34_ester_09_txt: AssetResource
  get() = CommonMainAssets22.names_34_ester_09_txt

public actual val SharedRes.assets.peopleNames.names_34_ester_txt: AssetResource
  get() = CommonMainAssets22.names_34_ester_txt

public actual val SharedRes.assets.peopleNames.names_35_daniel_01_txt: AssetResource
  get() = CommonMainAssets22.names_35_daniel_01_txt

public actual val SharedRes.assets.peopleNames.names_35_daniel_02_txt: AssetResource
  get() = CommonMainAssets22.names_35_daniel_02_txt

public actual val SharedRes.assets.peopleNames.names_35_daniel_04_txt: AssetResource
  get() = CommonMainAssets22.names_35_daniel_04_txt

public actual val SharedRes.assets.peopleNames.names_35_daniel_05_txt: AssetResource
  get() = CommonMainAssets22.names_35_daniel_05_txt

public actual val SharedRes.assets.peopleNames.names_35_daniel_08_txt: AssetResource
  get() = CommonMainAssets22.names_35_daniel_08_txt

public actual val SharedRes.assets.peopleNames.names_35_daniel_09_txt: AssetResource
  get() = CommonMainAssets22.names_35_daniel_09_txt

public actual val SharedRes.assets.peopleNames.names_35_daniel_10_txt: AssetResource
  get() = CommonMainAssets22.names_35_daniel_10_txt

public actual val SharedRes.assets.peopleNames.names_35_daniel_12_txt: AssetResource
  get() = CommonMainAssets22.names_35_daniel_12_txt
